import React, { useEffect, memo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { campaignGetWareAndTireSummaryRequest } from '../../../../_redux/_actions';
import UiDealerSelect from "../../../_uiComponents/common/UiDealerSelect";
import { participantJobRoleIds } from '../../../../_redux/_constants';

const WearAndTearChart = memo((props) => {

    const actionDispatch = useDispatch();

    const { teamPerformance, dealerships, areaManagerDealers, userProfileDetails } = useSelector((state) => {
        return {
            teamPerformance: state.campaign.teamPerformance,
            dealerships: state.auth.dealerships,
            areaManagerDealers: state.campaign?.areaManagerDealers,
            userProfileDetails: state.auth.userProfileDetails,
        };
    });

    useEffect(() => {
        if (dealerships?.dealerCode !== undefined) {
            actionDispatch(campaignGetWareAndTireSummaryRequest({ ...props, dealerCode: dealerships?.dealerCode }));
        }  
        let list = document.getElementById("sb-ol-list");
        if (list.childElementCount == 0) {

            for (let i = 0; i < 51; ++i) {
                let li = document.createElement('li');
                list.appendChild(li);
            }
        }
    }, [dealerships]);

    useEffect(() => {
        if(userProfileDetails?.jobRoleId == participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER && !props?.dealer && areaManagerDealers[0]?.code){
            actionDispatch(campaignGetWareAndTireSummaryRequest({ ...props, dealerCode: areaManagerDealers[0]?.code }));
        }
    }, [areaManagerDealers])

    return (
        <>
            <div className='sb-wear-and-tear-wr'>
                <h3>Team Performance </h3>
                <h5>{teamPerformance?.dealerName} </h5>
                <h5 className='sb-combined-target'>Combined target: £ {teamPerformance?.wearAndTearMyPerformanceData?.combinedTargetValue.toFixed(2)}</h5>
                <h4>Latest total: £ {teamPerformance?.wearAndTearMyPerformanceData?.latestTotalSaleValue.toFixed(2)}</h4>
            </div>
            <div className='sb-measure'>
                <div className='sb-measure__list'>
                    <ol id="sb-ol-list"></ol>
                </div>
                <div className='sb-target-chart'>
                    <div className='sb-target-chart__brake-discs' style={{ height: `${(teamPerformance?.wearAndTearMyPerformanceData?.brakeDisksSaleValuePercentage)}%` }}>
                        {teamPerformance?.wearAndTearMyPerformanceData?.brakeDisksSaleValue && <label>£ {teamPerformance?.wearAndTearMyPerformanceData?.brakeDisksSaleValue.toFixed(2)}</label>}
                    </div>
                    <div className='sb-target-chart__wiper-blade' style={{ height: `${(teamPerformance?.wearAndTearMyPerformanceData?.wiperBladeSalePercentage)}%` }}>
                        {teamPerformance?.wearAndTearMyPerformanceData?.wiperBladeSaleValue && <label>£ {teamPerformance?.wearAndTearMyPerformanceData?.wiperBladeSaleValue.toFixed(2)}</label>}
                    </div>
                    <div className='sb-target-chart__brake-pads' style={{ height: `${(teamPerformance?.wearAndTearMyPerformanceData?.brakePadsSaleValuePercentage)}%` }}>
                        {teamPerformance?.wearAndTearMyPerformanceData?.brakePadsSaleValue && <label>£ {teamPerformance?.wearAndTearMyPerformanceData?.brakePadsSaleValue.toFixed(2)}</label>}
                    </div>
                    <div className='sb-target-chart__battery' style={{ height: `${(teamPerformance?.wearAndTearMyPerformanceData?.batterySaleValuePercentage)}%` }}>
                        {teamPerformance?.wearAndTearMyPerformanceData?.batterySaleValue && <label>£ {teamPerformance?.wearAndTearMyPerformanceData?.batterySaleValue.toFixed(2)}</label>}
                    </div>

                    {props?.salesQuarter !== 4 && teamPerformance?.wearAndTearMyPerformanceData?.latestTotalSalePercentage >= 100 ?
                        <div className='sb-target-chart__latest-total-wr'>
                            <span className='sb-target-chart__winner'>WINNER</span>
                        </div> :
                        <div className='sb-target-chart__below-winner-wr'>
                            <span className='sb-target-chart__below-winner'></span>
                        </div>
                    }
                </div>

            </div>

            <div className='sb-target-chart-label' >
                <h4>Targeted Products</h4>
                <div className='sb-batter-label-top-column'>
                    <div className='sb-battery-label'>
                        <div className='sb-label-color-box'></div>
                        <div className='sb-label-right-col'>
                            <label>Battery </label>
                            {/* <span>£2.00</span> */}
                        </div>
                    </div>
                    <div className='sb-wiper-blade'>
                        <div className='sb-label-color-box'></div>
                        <div className='sb-label-right-col'>
                            <label>Wiper Blade </label>
                            {/* <span>£2.00</span> */}
                        </div>
                    </div>
                </div>
                <div className='sb-batter-label-bottom-column'>
                    <div className='sb-brake-pads'>
                        <div className='sb-label-color-box'></div>
                        <div className='sb-label-right-col'>
                            <label>Brake Pads</label>
                            {/* <span>£2.00</span> */}
                        </div>
                    </div>
                    <div className='sb-brake-discs'>
                        <div className='sb-label-color-box'></div>
                        <div className='sb-label-right-col'>
                            <label>Brake Discs</label>
                            {/* <span>£2.00</span> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className='sb-last-update'>
                Updated:  {teamPerformance?.lastUpdatedDate ? teamPerformance?.lastUpdatedDate : 'Currently awaiting updated Renault data'}

            </div>
        </>
    )
}
)
export default WearAndTearChart;